import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CustomFieldsWidgetShell} from '../../../../core-entity/widgets/custom-fields-widget/components/custom-fields-widget-shell';
import {useGetWidgetCustomFields} from '../../../../core-entity/widgets/custom-fields-widget/graphql/hooks/use-get-widget-custom-fields';

import {useContactCustomFieldHandlers} from '../../hooks/use-contact-custom-field-handlers';

interface Props {
    contactId: string;
    widget: Widget;
}

export function ContactCustomFieldsWidget(props: Props) {
    const handlers = useContactCustomFieldHandlers(props.contactId);
    const {customFields, isFirstLoad} = useGetWidgetCustomFields(props.contactId, props.widget.id);

    return (
        <CustomFieldsWidgetShell
            entityId={props.contactId}
            widget={props.widget}
            handlers={handlers}
            emptyStateKey='leadCustomFields'
            customFields={customFields}
            isFirstLoad={isFirstLoad}
        />
    );
}
